import { FC, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { IconSearch, IconX } from '@tabler/icons-react';
import { useTheme } from '@mui/material/styles';
import useDebounce from '@hooks/useDebounce/useDebounce.ts';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

const TableSearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  onClear,
}) => {
  const theme = useTheme();
  const [inputValue, setInputValue] = useState(value);
  const debouncedValue = useDebounce(inputValue, 300);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue, onChange]);

  const handleClear = () => {
    setInputValue('');
    onClear();
  };

  return (
    <TextField
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder="Search..."
      sx={{
        '& .MuiInputBase-root': {
          backgroundColor: theme.palette.background.paper,
        },
        '& .MuiInputBase-input': {
          backgroundColor: theme.palette.background.paper,
        },
      }}
      InputProps={{
        startAdornment: (
          <IconSearch size={20} color="gray" style={{ marginRight: 10 }} />
        ),
        endAdornment: value && (
          <IconX
            size={20}
            color="gray"
            style={{ cursor: 'pointer' }}
            onClick={handleClear}
          />
        ),
      }}
    />
  );
};

export default TableSearchInput;
